module.exports = __webpack_public_path__ + "img/marinas-yacht-clubs.2753b72e.jpg";